/* eslint-disable */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/style.css";
import "windi.css";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import baiduMap from "vue-baidu-map";
Vue.use(baiduMap, { ak: "Q0g72W3OmG3lcnBUEOUXuAZzxMLe6ytQ" });

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(BootstrapVue);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

